import { useMemo } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useFormik } from 'formik';

import { FProgressBar } from '../../../../../../components/base';
import { useFormReadOnly } from '../../../../../common';
import AssessmentSummaryFields from './AssessmentSummaryFields';
import { useSaveTreatmentPlanV3PageField } from '../../../../hooks';
import {
  getCombinedAssessmentDsm5Symptoms,
  mapAssessmentPageToSummaryValues,
  toAssessmentSummaryFieldPayload,
} from '../utils';
import { ASSESSMENT_SUMMARY_FORM_SCHEMA } from '../validationSchema';
import { TREATMENT_PLAN_V3_SECTION_HEADING_SX } from '../../../../styles';

import type { AssessmentSummarySectionProps } from './types';

export default function AssessmentSummarySection({
  assessmentPage,
  templates,
  disabled,
  isUpdating,
  onUpdate,
}: AssessmentSummarySectionProps) {
  const readOnly = useFormReadOnly();
  const initialValues = useMemo(
    () => mapAssessmentPageToSummaryValues(assessmentPage),
    [assessmentPage],
  );
  const formik = useFormik({
    initialValues,
    validateOnBlur: true,
    validateOnChange: true,
    validateOnMount: true,
    validationSchema: ASSESSMENT_SUMMARY_FORM_SCHEMA,
    onSubmit: () => undefined,
  });
  const { saveField } = useSaveTreatmentPlanV3PageField({
    formik,
    initialValues,
    onUpdate,
    toPayload: toAssessmentSummaryFieldPayload,
    validationSchema: ASSESSMENT_SUMMARY_FORM_SCHEMA,
  });

  return (
    <Stack gap={2}>
      <Typography variant="h5" sx={TREATMENT_PLAN_V3_SECTION_HEADING_SX}>
        Summary of assessment
      </Typography>
      <Box component="form" noValidate onSubmit={formik.handleSubmit}>
        {isUpdating ? <FProgressBar /> : null}
        <AssessmentSummaryFields
          disabled={disabled}
          dsm5SymptomsText={getCombinedAssessmentDsm5Symptoms(
            assessmentPage.behaviors,
            assessmentPage.no_maladaptive_behavior,
          )}
          formik={formik}
          readOnly={readOnly}
          saveField={saveField}
          templates={templates}
        />
      </Box>
    </Stack>
  );
}
